<template>
  <dx-data-grid
    ref="versionImportDataGrid"
    :height="height"
    :data-source="dataSource"
    :show-borders="false"
    :show-column-lines="false"
    :show-row-lines="true"
    :column-auto-width="true"
    :allow-column-reordering="!gridTouch"
    :allow-column-resizing="!gridTouch"
    :hover-state-enabled="!gridTouch"
    :element-attr="gridAttr"
    :columns="columns"
    :summary="summary"
    :focused-row-enabled="true"
    :repaint-changes-only="true"
    :two-way-binding-enabled="false"
    :columnAutoWidth="true"
    @toolbar-preparing="onToolbarPreparing($event)"
    @content-ready="$emit('content-ready', $event)"
    @focused-row-changed="onFocusedRowChanged"
    :scrolling="scrolling"
  >
    <slot></slot>
    <dx-filter-row :visible="false" />
    <dx-search-panel :visible="false" />
    <dx-paging :page-size="defaultPageSize" />
    <!-- Seitenwahl und Blättern in der Fußleiste der Seite (AppGridFooter, Version.vue) -->
    <dx-pager :visible="false" />

    <!-- Status als Text mit Icon (R4): läuft Amber, erfolgreich Grau, fehlerhaft Rot -->
    <template #importStatusCellTemplate="cell">
      <div>
        <span
          v-if="cell.data.data.import_status === 'RUNNING'"
          class="import-status import-status--running"
        >
          <app-icon name="refresh" :size="16" class="rotateing" />Import läuft
        </span>

        <span
          v-if="cell.data.data.import_status === 'SUCCESSFULL'"
          class="import-status import-status--done"
        >
          <app-icon name="check" :size="16" />Import erfolgreich
        </span>

        <span
          v-if="cell.data.data.import_status === 'FAILED'"
          class="import-status import-status--failed"
        >
          <app-icon name="alertTriangle" :size="16" />Import fehlerhaft
        </span>
      </div>
    </template>

    <template #versionIdCellTemplate="cell">
      <div>
        {{(cell.data.data.version_id &lt; 0) ? "?" : cell.data.data.version_id}}
      </div>
    </template>


  </dx-data-grid>
</template>

<script>
import axios from "axios";
import CustomStore from "devextreme/data/custom_store";
import {
  DxDataGrid,
  DxSearchPanel,
  DxFilterRow,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";

export default {
  components: {
    DxDataGrid,
    DxSearchPanel,
    DxFilterRow,
    DxPaging,
    DxPager,
  },

  mixins: [DataGridMixin],
  // height: Höhe des Grids (Seite füllt das Blatt: "100%"; Handy: natürliche Höhe); Ereignis content-ready für die
  // Fußleiste der Seite
  // Eine Zeile wählen (Klick, Tastatur) meldet select (Zeile); die Seite zeigt das Import-Log daneben im Detailbereich
  // (Kundenwunsch 13.10.2026: „statt inline das aufklappen dann bitte rechts daneben eine zusätzliche spalte so wie die
  // detailansicht der verkäufe“, Chevron und Aufklappen entfallen).
  props: ["dataSource", "columns", "summary", "height"],
  data() {
    return {
      // Zeiger auf den Zeilen: ein Klick öffnet das Import-Log im Detailbereich
      gridAttr: { class: "app-grid--detail" },
      logDataSource: {
        store: new CustomStore({
          key: ["id"],
          load: () =>
            axios.get(
              `${this.$store.state.baseUrl}versionimportlog?version_id=60`
            ),
        }),
        reshapeOnPush: true,
      },
    };
  },
  methods: {
    refreshDataGrid() {
      this.$refs["versionImportDataGrid"].instance.refresh();
    },
    searchByText(text) {
      this.$refs["versionImportDataGrid"].instance.searchByText(text || "");
    },
    onFocusedRowChanged(e) {
      if (e.row && e.row.rowType === "data") {
        this.$emit("select", e.row.data);
      }
    },
    // Auswahl aufheben (Detailbereich geschlossen)
    clearFocus() {
      const grid = this.$refs["versionImportDataGrid"].instance;
      if (grid.option("focusedRowIndex") !== -1) {
        grid.option("focusedRowIndex", -1);
      }
    },
    updateDimensions() {
      this.$refs["versionImportDataGrid"].instance.updateDimensions();
    },
    onToolbarPreparing(e) {
      // Remove all default toolbar items; die leere Leiste ganz ausblenden (sonst zweite Linie über dem Tabellenkopf)
      e.toolbarOptions.items = [];
      e.toolbarOptions.visible = false;
    },
  },
};
</script>

<style scoped>
.import-status {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  color: var(--ink-3);
}
.import-status--running {
  font-weight: 500;
  color: var(--amber);
}
.import-status--failed {
  font-weight: 500;
  color: var(--red);
}

.rotateing {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>